import { MAX_CHARACTER_EMAIL_VALIDATION, MAX_CHARACTER_INPUT_VALIDATION, MAX_CHARACTER_ORGANIZATION_ID_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";

export const loginSchema = validator.object().shape({
  ownerId: validator
    .string()
    .trim()
    .emptyToNull()
    .autoTransformToHalfWidthForMatchLicenseNumber()
    .label("組織ID")
    .max(MAX_CHARACTER_ORGANIZATION_ID_VALIDATION)
    .required(),
  email: validator.string().trim().emptyToNull().max(MAX_CHARACTER_EMAIL_VALIDATION).label("メールアドレス").required(),
  password: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("パスワード").required(),
});
